import { useEffect, useState } from 'react';
import NoDataCard from '../../components/no-data-card';
import SkeletonLoader from '../../utilites/SkeltonLoader';
import { SpinnerLoader } from '../../assets/loader/loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { RecentActivityIcon } from '../../assets/common-svg/CommonSvg';
import { Box, Typography } from '@mui/material';
import DashboardApi from '../../services/dashboardService';

let recentActivityFilter = {
    page: 1,
    limit: 10,
    maxPages: null,
};

const RecentActivity = ({
    limitNotifications = null,
}) => {
    const [spinner, setSpinner] = useState(false);
    const isLimitedView = Number.isInteger(limitNotifications);
    const [recentActivityData, setRecentActivityCRData] = useState([]);
    const [raLoading] = useState(false);
    const [, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
  

    const PageIncrement = () => {
        recentActivityFilter.page += 1;
    };
    const ResetFilter = () => {
        recentActivityFilter.page = 1;
    };
    const getRecentActivity = async () => {
        recentActivityFilter.page === 1 && setLoading(true);
        setSpinner(true);
        try {
             const res = await DashboardApi.getAllRecentActivityList(recentActivityFilter.page,recentActivityFilter.limit);
            const data = res?.data || [];

            recentActivityFilter.maxPages = Math.ceil(
                res?.page_details?.no_of_records / recentActivityFilter.limit
            );

            setRecentActivityCRData(prev =>
                recentActivityFilter.page > 1 ? [...prev, ...data] : data
            );
        } finally {
            setSpinner(false);
            setInitialLoad(false);
        }
    };
    useEffect(() => {
        ResetFilter();
        getRecentActivity();
        PageIncrement()
    }, []);

    const fetchData = () => {
        if (recentActivityFilter?.page <= recentActivityFilter?.maxPages) {
            getRecentActivity();
            PageIncrement();
        }
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="overflow-auto scroll-smooth bg-white pl-[15px]">
                {initialLoad ? (
                    <SkeletonLoader rowCount={5} isTable={false} />
                ) : !initialLoad && recentActivityData.length === 0 ? (
                    <div className="mt-4">
                        <NoDataCard />
                    </div>
                ) : isLimitedView ? (
                    <>
                        {recentActivityData.map((item,index) => {
                            return (
                                <>
                                    <Box display="flex"
                                        alignItems="center"
                                        gap={1}
                                        key={index}
                                        border={1}
                                        borderColor="#d5d5d5"
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <RecentActivityIcon />
                                        </Box>
                                        <Box display="flex" flexDirection="column">
                                            <Typography variant="h6" fontWeight={400}>
                                                {item.activity}
                                            </Typography>
                                            <Typography variant='body2' color="#828282">
                                                {item.activity_date}
                                                <span style={{ margin: "0 6px" }}>|</span>
                                                {item.time}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </>)
                        })}


                        {!raLoading && recentActivityData.length === 0 && (
                            <Typography fontSize="13px" color="text.secondary">
                                No recent activity
                            </Typography>
                        )}

                    </>
                ) : (
                    <InfiniteScroll
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4"
                        dataLength={recentActivityData.length}
                        next={fetchData}
                        hasMore={recentActivityFilter.page <= recentActivityFilter.maxPages}
                        loader={
                            spinner && (
                                <div className="flex justify-center">
                                    <SpinnerLoader />
                                </div>
                            )
                        }
                        scrollThreshold={0.9}
                    >
                        {recentActivityData.map((item) => {
                            return (
                                <>
                                    <Box
                                        display="flex"
                                        alignItems="flex-start"
                                        gap={1.5}
                                        sx={{
                                            pt: "1rem",
                                            pb: "1rem",
                                        }}
                                        borderBottom="1px solid #E5E7EB"
                                    >

                                        <span
                                            className='flex align-center justify-center'>
                                            <RecentActivityIcon />
                                        </span>
                                        <Box display="flex" flexDirection="column" gap={0.3}>
                                            <Typography
                                                variant='h6'
                                                fontWeight={400}
                                                color="#000000"
                                                lineHeight="18px"
                                            >
                                                {item.activity}
                                            </Typography>
                                            <Typography
                                                variant='body2'
                                                color="#828282"
                                            >
                                                {item.activity_date} {item.time}
                                            </Typography>
                                        </Box>
                                    </Box>


                                </>)

                        })}
                    </InfiniteScroll>
                )}
            </div>
        </div >
    );
};

export default RecentActivity;
